<template>
  <div>
    <b-container fluid>
      <b-row v-if="notEmptyObject(this)">
        <b-col cols="12">
          <solicitud-card :solicitud="this.SolicitudSeleccionada"></solicitud-card>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12">
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
              <b-form-row>
                <b-col cols="1">
                  <b-form-group id="inputValidar-group" label="Validar" label-for="inputValidar">
                    <b-form-checkbox
                        id="inputValidar"
                        v-model="inputValidar"
                        name="inputValidar"
                      >
                        Validar
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="11">
                  <b-form-group v-if="mostrarcie10">
                    <div>
                      <label class="typo__label" for="msDiagnostico">Diagnóstico (CIE10)</label>
                      <multiselect
                        v-model="CIE10"
                        id="msDiagnostico"
                        label="ToString"
                        track-by="Id"
                        placeholder="Haga click para buscar"
                        open-direction="bottom"
                        :max-height="900"
                        :options="diagnosticos"
                        :searchable="true"
                        :internal-search="false"
                        :clear-on-select="false"
                        @search-change="asyncFind"
                        :close-on-select="true"
                        :show-no-results="false"
                        :disabled="disabled"
                      >
                        <span slot="noResult">Oops! No se encontraron resultados.</span>
                      </multiselect>
                    </div>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <tipo-licencia-select></tipo-licencia-select>
              <b-form-row>
                <b-col cols="6">
                  <validation-provider name="fechaDesde" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group id="inputFechaDesde-group" label="Ausente desde" label-for="inputFechaDesde">
                      <b-form-datepicker
                        id="inputFechaDesde"
                        v-model="inputFechaDesde.value"
                        placeholder="Licencia desde"
                        :disabled="disabled"
                        :min="inputFechaDesde.min"
                        :max="inputFechaDesde.max"
                        :state="checkForm(validationContext)"
                      ></b-form-datepicker>
                      <b-form-invalid-feedback id="inputFechaDesde-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <validation-provider v-if="true" name="cantidadDias" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group
                      id="inputCantidadDias-group"
                      label="Cantidad de días a otorgar:"
                      label-for="inputCantidadDias"
                    >
                      <b-input-group>
                        <b-form-input
                          id="inputCantidadDias"
                          type="number"
                          min="0"
                          v-model="inputCantidadDias"
                          :disabled="disabled"
                          :state="checkForm(validationContext)"
                        />
                        <b-input-group-append>
                          <b-button @click="calcularFechaHasta()" variant="warning">Calcular</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                    <b-form-invalid-feedback id="inputCantidadDias-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col cols="4">
                  <validation-provider name="fechaHasta" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group id="inputFechaHasta-group" label="Ausente hasta" label-for="inputFechaHasta">
                      <b-form-datepicker
                        id="inputFechaHasta"
                        v-model="inputFechaHasta.value"
                        placeholder="Ausente hasta"
                        :disabled="disabled"
                        :min="inputFechaHasta.min"
                        :state="checkForm(validationContext)"
                      ></b-form-datepicker>
                      <b-form-invalid-feedback id="inputFechaHasta-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="8">
                  <validation-provider v-if="true" name="observaciones" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group id="inputObservaciones-group" label="Observaciones :" label-for="inputObservaciones">
                    <b-form-textarea
                      id="inputObservaciones"
                      v-model="inputObservaciones"
                      placeholder=""
                      rows="3"
                      max-rows="6"
                      :disabled="disabled"
                      :state="checkForm(validationContext)"
                    ></b-form-textarea>
                    </b-form-group>
                    <b-form-invalid-feedback id="inputObservaciones-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col class="text-right">
                  <b-button :disabled="disabled" class="mb-2" variant="warning" v-on:click="cerrarFormulario()">Cancelar</b-button>
                  <b-button :disabled="disabled" class="mb-2" type="submit" variant="warning">Guardar</b-button>
                </b-col>
              </b-form-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import api from "@/api";
import Ciesvc from "@/services/cie10";
import moment from "moment";
import Multiselect from "vue-multiselect";
import SolicitudCard from "../../common/SolicitudCard.vue";
import TipoLicenciaSelect from '../../common/TipoLicenciaSelect.vue'
import { mapGetters, mapActions } from "vuex";
import DetalleCalendarFeriadosvc from '@/services/detallecalendarioferiado'
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'

import { createHelpers } from 'vuex-map-fields';

const { mapFields: mapFormLicenciaFields } = createHelpers({
  getterType: 'FormLicenciaModule/getLicenciaField',
  mutationType: 'FormLicenciaModule/updateLicenciaField',
});
const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "RegistrarLicenciaForm",
  mixins: [errorhandler, swalerts],
  components: { Multiselect, SolicitudCard, TipoLicenciaSelect },
  props: {
  },
  computed: {
    ...mapGetters([
      "getUserInfo",
      "getUserName",
      "getEstablecimiento",
      "isInRoleAdmin",
      "isInRoleCoordinador",
      "isInRoleEstablecimiento"
    ]),
    ...mapFormBuscarPersonalFields(['Personal']),
    ...mapFormLicenciaFields([
      "FechaDesde",
      "CantidadDias",
      "Fecha",
      "SolicitudSeleccionada",
      "SolicitudSeleccionada_Id",
      "CIE10",
      "CIE10_Id",
      "TipoLicencia",
      "TipoLicencia_Id",
      "DetalleDiasLicencia",
      "DetalleDiasLicencia_Id",
      "mostrarcie10",
      "Observaciones"]),
  },
  watch: {
  },
  mounted(){
    this.inputFechaDesde.value = this.SolicitudSeleccionada.FechaDesde;
    this.inputFechaHasta.value = this.SolicitudSeleccionada.FechaDesde;
    this.inputCantidadDias = this.SolicitudSeleccionada.CantidadDias;
    this.TipoLicencia_Id = null;
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 4){ //art17
      this.TipoLicencia_Id = 13;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 5){//art30
      this.TipoLicencia_Id = 35;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 6){//art32
      this.TipoLicencia_Id = 37;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 7){//art33
      this.TipoLicencia_Id = 38;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 8){//art28
      this.TipoLicencia_Id = 31;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 9){//art14ext
      this.TipoLicencia_Id = 7;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 2){//covid
      this.TipoLicencia_Id = 85;
      this.mostrarcie10 = true;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 0){//medica
      this. mostrarcie10 = true;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 1){//accidente
      this.mostrarcie10 = true;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 10){//art20a
      this.TipoLicencia_Id = 17;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 11){//art20b
      this.TipoLicencia_Id = 18;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 12){//art20c
      this.TipoLicencia_Id = 19;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 13){//art27
      this.TipoLicencia_Id = 30;
    }
    if(this.SolicitudSeleccionada.TipoSolicitudMedica === 14){//art48
      this.TipoLicencia_Id = 88;
    }
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th 2 year prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 110); // Desde 2015
    minDate.setDate(15);
    // 15th in 6 months
    const maxDate = new Date(today);
    maxDate.setMonth(maxDate.getMonth() + 6);
    maxDate.setDate(15);
    return {
      diasSemana: [1, 2, 3, 4, 5],
      personal_id: 0,
      cargopersonal_id: 0,
      disabled: null,
      tituloreglicform: "Registrar Licencia",
      articuloSelected: [],
      arregloArticulos: [],
      diagnosticos: [],
      arrDetalleDiasLicencia: [],
      instanciaSeleccionada: {},
      disabled: false,
      inputFechaDesde: {
        value: new Date(),
        min: minDate,
        max: maxDate
      },
      inputFechaHasta: {
        value: new Date(),
        min: minDate
      },
      inputCantidadDias: null,
      inputAdjunto: null,
      inputObservaciones: null,
      inputFechaActual: null,
      inputValidar: true,
    };
  },
  methods: {
    cerrarFormulario(mensaje){
      console.log('cerrarFormulario');
      this.limpiarFormulario();
      this.$emit('form-licencia-close', mensaje);
    },
    checkForm: function({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      console.log('onSubmit');
      this.registrarLicencia();
    },
    limpiarFormulario() {
      console.log('limpiarFormulario');
      this.SolicitudSeleccionada = null;
      this.TipoLicencia = null;
      this.TipoLicencia_Id = null;
      this.DetalleDiasLicencia = null;
      this.CIE10 = null;
      this.mostrarcie10 = false;
    },
    emitirConstancia(id) {
      console.log('emitirConstancia', id);
      let url = api.url + "/LicenciaCargoPersonal/GetConstanciaPdf/" + id;
      window.open(url);
    },
    registrarLicencia() {
      if (!this.TipoLicencia) {
        alert("Debe seleccionar un artículo");
        return;
      }else if (!this.DetalleDiasLicencia) {
        alert("Debe seleccionar una instancia del artículo");
        return;
      }
      this.disabled = true;
      console.log(this.TipoLicencia, this.DetalleDiasLicencia, this.SolicitudSeleccionada);
      this.showConfirmarDanger(`
        ${this.SolicitudSeleccionada.PersonalString}
        Articulo: ${this.TipoLicencia.Articulo}
        Instancia: ${this.DetalleDiasLicencia.Descripcion}
        Cantidad de días: ${this.inputCantidadDias}
        Desde ${moment(this.inputFechaDesde.value).format("DD-MM-YYYY")} Hasta ${moment(this.inputFechaHasta.value).format("DD-MM-YYYY")}
      `, 'Crear Licencia')
      .then((willChange) => {
        console.log('then willChange', willChange);
        if (willChange.isConfirmed) {
          this.crearLicencia()
            .then(r => {
              this.disabled = false;
              console.log('result crear', r);
              if ((this.isInRoleCoordinador || this.isInRoleAdmin) && (this.SolicitudSeleccionada.TipoSolicitudMedica === 0 || this.SolicitudSeleccionada.TipoSolicitudMedica === 1 || this.SolicitudSeleccionada.TipoSolicitudMedica === 2)) {
                this.emitirConstancia(r.data.objeto.Nuevo.Id);
              }
              this.cerrarFormulario(r.data.status.mensaje);
              return r;
            })
            .catch(e => {
              this.disabled = false;
              this.errorHandler(e);
            });
        }else{
          this.disabled = false;
        }
      });
    },
    crearLicencia() {
      this.inputFechaActual = moment();
      //TODO: validar que la fecha desde sea dia habil.
      return LicenciaCargoPersonalSvc.crear({
        Validar: this.inputValidar,
        Personal_Id: this.SolicitudSeleccionada.Personal_Id,
        CargoPersonal_Id: null,
        TipoLicencia_Id: this.TipoLicencia.Id,
        DetalleDiasLicencia_Id: this.DetalleDiasLicencia.Id,
        Observaciones: this.inputObservaciones,
        LicenciaDesde: this.inputFechaDesde.value,
        LicenciaHasta: this.inputFechaHasta.value,
        CantidadDias: this.inputCantidadDias,
        EstadoLicenciaCargoPersonal: 1,
        Notificar: true,
        SolicitudMedica_Id: this.SolicitudSeleccionada.Id,
        CIE10_Id: this.CIE10 ? this.CIE10.Id : null,

        TipoSolicitudMedica: this.SolicitudSeleccionada.TipoSolicitudMedica,
        TipoContagio: this.SolicitudSeleccionada.TipoContagio,

        AntiguedadDias : this.DetalleDiasLicencia.AntiguedadDias,
        MaximoDias : this.DetalleDiasLicencia.MaximoDias,
        MinimoDias : this.DetalleDiasLicencia.MinimoDias,
        DiasContinuos: this.DetalleDiasLicencia.DiasContinuos,
        DiasHabiles: this.DetalleDiasLicencia.DiasHabiles,
        PorcentajeSueldo : this.DetalleDiasLicencia.PorcentajeSueldo,
        Frecuencia: this.DetalleDiasLicencia.Frecuencia,
        //NivelEnseñanza_Id: this.SolicitudSeleccionada.NivelEnseñanza_Id,
        //UnidadEducativa_Id: this.SolicitudSeleccionada.UnidadEducativa_Id,
        //UnidadAdministrativa_Id: this.SolicitudSeleccionada.UnidadAdministrativa_Id,
      })
    },
    obtenerFechaActual() {
      this.txtFechaPresentacion = moment().format("YYYY-MM-DD");
    },
    esDiaSemana: function(dia) {
      return this.diasSemana.indexOf(dia) >= 0;
    },
    obtenerFechaHasta: function(fechaparam, cantDiasparam){
      console.log('Calcular fin dias habiles ', fechaparam, cantDiasparam);
      return DetalleCalendarFeriadosvc.getLista({fechadesde:fechaparam.format('YYYY-MM-DD')}).then(d => {
        if (!fechaparam.isValid()) {
            console.log('Fecha no valida', fechaparam);
            return null;
        }
        console.log('DetalleDiasLicencia', this.DetalleDiasLicencia);
        console.log('DiasHabiles', this.DetalleDiasLicencia.DiasHabiles);
        if(!this.DetalleDiasLicencia.DiasHabiles){
          var fechaRetornada = moment(fechaparam).add(cantDiasparam, 'days').subtract(1, 'days').format();
          return fechaRetornada;
        }
        var diasFeriados = d.data.rows.map(x =>
          moment(x.Fecha).format("YYYY-MM-DD")
        );
        console.log('diasFeriados', diasFeriados);
        var cantidad = cantDiasparam < 0 ? -1 : 1;
        var restante = Math.abs(cantDiasparam) - 1;//se resta 1 para restar la primer fecha habil elegida.

        while (restante > 0) {
          var esFeriado = diasFeriados.indexOf(fechaparam.format('YYYY-MM-DD')) >= 0;
          var esDiaSemana =  this.esDiaSemana(fechaparam.day());
          console.log('esDiaSemana', esDiaSemana);
          if(esDiaSemana){
            if(!esFeriado){
              restante--;
            }
          }
          fechaparam.add(cantidad,'days');
        }
        return fechaparam.format('YYYY-MM-DD');
      });
    },
    // TODO: utilziar funcion contarFeriados y contarDiasHabiles
    calcularFechaHasta() {
      if(this.DetalleDiasLicencia === null){
        alert(`No se puede calcular la Fecha de Fin de la Licencia sin la instancia cargada.`);
      }
      let ausenteDiaSemana = !this.esDiaSemana(moment(this.inputFechaDesde.value).day()) && this.DetalleDiasLicencia.DiasHabiles;
      if(ausenteDiaSemana){
        alert(`La fecha ausente desde debe ser un día hábil para la instancia ${this.DetalleDiasLicencia.Descripcion}`);
        return;
      }
      this.disabled = true;
      console.log('obtenerFechaHasta', this.inputCantidadDias, this.inputFechaDesde.value);
      return this.obtenerFechaHasta(moment(this.inputFechaDesde.value), this.inputCantidadDias)
      .then(r => {
        console.log("fechaHasta", r);
        if (r === null) {
          throw "No se pudo calcular la Fecha de Fin de la Licencia.";
        }
        console.log('fin obtenerFechaHasta', r);
        this.inputFechaHasta.value = r;

        this.disabled = false;
      })
      .catch(e => {
        console.log("Error al calcular Fecha", e);
        this.disabled = false;
        this.errorHandler(e);
      });
    },
    buscarDiagnostico(query) {
      return Ciesvc.getLista({ search: query });
    },
    asyncFind(query) {
      this.diagnosticos = [];
      this.buscarDiagnostico(query)
        .then(response => {
          response.data.rows.forEach(d => {
            this.diagnosticos.push(d);
          });
        })
        .catch(error => {
          console.log("Error al obtener diagnósticos");
        });
    },
    customLabel({ Regimen, Articulo, Descripcion }) {
      return `${Regimen} – ${Articulo} - ${Descripcion}`;
    },
    findByNameArticle(query) {
      this.arregloArticulos = [];
      this.findArticle(query)
        .then(response => {
          this.arregloArticulos = response.data.rows;
        })
        .catch(error => {
          console.log("Error al obtener artículos");
        });
    },
    dispatchAction(articulo) {
      this.obtenerDetalles(articulo.Id);
      console.log("Me ejecute");
    }
  }
};
</script>

<style >
.invalid-feedback {
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/licencias/RegistrarLicenciaForm.vue